(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* O tamanho escolhido troca a variante do formulário, o preço, o Pix e o
       texto do botão. O resto (adicionar, abrir a sacola) é do tema. */
    function iniciar(secao) {
      if (secao.dataset.frenesiRecPronto === '1') return;
      secao.dataset.frenesiRecPronto = '1';

      secao.addEventListener('click', (evento) => {
        const botao = evento.target.closest('.frenesi-rec__tam');
        if (!botao || botao.disabled) return;
        const card = botao.closest('[data-frenesi-rec-card]');
        if (!card) return;

        card.querySelectorAll('.frenesi-rec__tam').forEach((outro) => {
          outro.setAttribute('aria-pressed', String(outro === botao));
        });
        const variante = card.querySelector('input[name="id"]');
        if (variante) variante.value = botao.dataset.variante;

        const preco = card.querySelector('[data-frenesi-preco]');
        const pix = card.querySelector('[data-frenesi-pix]');
        const de = card.querySelector('[data-frenesi-de]');
        if (preco) preco.textContent = botao.dataset.precoTxt;
        if (pix) pix.textContent = botao.dataset.pixTxt;
        if (de) {
          de.textContent = botao.dataset.deTxt || '';
          de.hidden = !botao.dataset.deTxt;
        }
        const rotulo = card.querySelector('.add-to-cart-text__content > span > span');
        if (rotulo) rotulo.textContent = 'Adicionar ' + botao.dataset.ml + ' ml';
      });

      /* Celular: os tracinhos acompanham o carrossel. */
      const trilho = secao.querySelector('[data-frenesi-rec-trilho]');
      const pontos = secao.querySelectorAll('.frenesi-rec__progresso span');
      if (!trilho || pontos.length < 2) return;
      trilho.addEventListener(
        'scroll',
        () => {
          const primeiro = trilho.querySelector('[data-frenesi-rec-card]');
          if (!primeiro) return;
          const passo = primeiro.getBoundingClientRect().width + 12;
          let atual = Math.round(trilho.scrollLeft / passo);
          if (trilho.scrollLeft + trilho.clientWidth >= trilho.scrollWidth - 4) atual = pontos.length - 1;
          pontos.forEach((ponto, n) => ponto.classList.toggle('is-ativo', n === Math.min(atual, pontos.length - 1)));
        },
        { passive: true }
      );
    }

    const todas = () => document.querySelectorAll('[data-frenesi-rec]').forEach(iniciar);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', todas, { once: true });
    } else {
      todas();
    }
    document.addEventListener('shopify:section:load', todas);
  })();

  } catch(e) { console.error(e); }
})();
})();
